// --- API Hooks ---
import {
  useGetSavedForLaterItemIdsQuery,
  useGetSavedForLaterItemsDataQuery,
  useAddSavedForLaterItemMutation,
  useRemoveSavedForLaterItemMutation,
} from "../templates/ecommerce/savedForLater/api/savedForLaterApi";

// --- Custom Logic Hooks ---
import { useAddToSavedForLater } from "../templates/ecommerce/savedForLater/hooks/useAddToSavedForLater";
import { useRemoveFromSavedForLater } from "../templates/ecommerce/savedForLater/hooks/useRemoveFromSavedForLater";
import { useMoveSavedForLaterItemBackToCart } from "../templates/ecommerce/savedForLater/hooks/useMoveSavedForLaterItemBackToCart";
import { useMoveSavedForLaterItemToWishlist } from "../templates/ecommerce/savedForLater/hooks/useMoveSavedForLaterItemToWishlist";
import { useMoveToSavedForLaterFromCart } from "../templates/ecommerce/savedForLater/hooks/useMoveToSavedForLaterFromCart";

// --- UI Components ---
import PageSavedForLaterList from "../templates/ecommerce/savedForLater/components/Page/PageSavedForLaterList";
import PanelSavedForLaterList from "../templates/ecommerce/savedForLater/components/Panel/PanelSavedForLaterList";

export const savedForLater = {
  // 1. API Data Fetching
  api: {
    useGetSavedForLaterItemIdsQuery,
    useGetSavedForLaterItemsDataQuery,
    useAddSavedForLaterItemMutation,
    useRemoveSavedForLaterItemMutation,
  },

  // 2. Logic Hooks (Orchestration logic)
  hooks: {
    useAddToSavedForLater,
    useRemoveFromSavedForLater,
    useMoveSavedForLaterItemBackToCart,
    useMoveSavedForLaterItemToWishlist,
    useMoveToSavedForLaterFromCart,
  },

  // 3. UI Components
  components: {
    PageSavedForLaterList,
    PanelSavedForLaterList,
  },
};
